import styled from "styled-components";

export const Container = styled.div`
  /* padding-left: 15px; */
  & input {
    transform: scale(1.5);
  }
  & span {
    font-size: 20px;
    padding-left: 5px;
  }
`;
